/**
 * @fileoverview An organization administrator's own email switches, as
 * Settings › Preferences lists them. Mirrors `mobile/src/lib/orgEmailPreferences.js`;
 * the keys are the backend's `ADMIN_EMAIL_PREFERENCES`
 * (`backend/tests/test_org_email_preferences_parity.py` holds the three together).
 *
 * Each email is on until the admin switches it off. The organization's own
 * switches still decide whether an email exists at all (a program's "Weekly
 * recap", the Notifications page); these decide only whether this admin gets it.
 */

export const ORG_EMAIL_PREFERENCES = Object.freeze([
  {
    key: "program_emails",
    label: "Program emails",
    desc: "Each program's weekly recap and week ahead, for the programs that send them.",
  },
  {
    key: "program_announcements",
    label: "Program announcements",
    desc: "A copy of the announcements other admins send to a program's or a class's instructors.",
  },
  {
    key: "org_recap",
    label: "Organization recap",
    desc: "One weekly recap of what was taught across every program.",
  },
  {
    key: "org_week_ahead",
    label: "Organization week ahead",
    desc: "One look at the coming week across every program.",
  },
]);
